<template>
  <div class="home-swiper-container" v-if="isShow">
    <swiper :options="howToSwiper">
      <swiper-slide v-for="(p, idx) in item.Products" :key="'mySwiperSlide__'+idx" v-if="!p.IsStopSale">
        <productCard
          v-bind:img="p.Thumbnail"
          v-bind:link="p.link"
          v-bind:brand="p.Brand"
          v-bind:rating="p.Rating"
          v-bind:name="p.Name"
          v-bind:description="p.Description"
          v-bind:isPromotion="p.IsPromotion"
          v-bind:price="p.Price"
          v-bind:item="p"
          v-bind:quantity="p.Quantity"
          v-bind:key="'productCard_'+idx"
          v-bind:isZoom="false"
          v-show="true"
          v-bind:refNum="p.RefNum"
          v-bind:productNum="p.ProductNum"
        ></productCard>
      </swiper-slide>
    </swiper>
    <div class="swiper-button-prev" :class="`swiper-button-prev-${index}`" slot="button-prev">
      <font-awesome-icon icon="chevron-left" :style="{ color: 'black', fontSize: '20px', marginRight: '10px' }"/>
    </div>
    <div class="swiper-button-next" :class="`swiper-button-next-${index}`" slot="button-next">
      <font-awesome-icon icon="chevron-right" :style="{ color: 'black', fontSize: '20px', marginLeft: '10px'  }"/>
    </div>
  </div>
</template>

<script>
import productCard from "../../view/productCard";
import {locales} from "../../mixin";

export default {
  name: "home-swiper",
  mixins: [locales],
  components: {
    productCard
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      howToSwiper: {},
      isShow: false
    }
  },
  mounted() {
    this.howToSwiper = {
      slidesPerView: 5,
      navigation: {
        prevEl: `.swiper-button-prev-${this.index}`,
        nextEl: `.swiper-button-next-${this.index}`,
      },
      breakpoints: {
        320: {
          slidesPerView: 2,
        },
        //when width >= 480
        480: {
          slidesPerView: 2,
        },
        767: {
          slidesPerView: 2,
        },
        //when width >= 640
        990: {
          slidesPerView: 2,
        },
        1200: {
          slidesPerView: 4,
        },
        1280: {
          slidesPerView: 4,
        }
      }
    }
    this.isShow = true
  }
}
</script>

<style lang="less">
.home-swiper-container {

}
</style>



// WEBPACK FOOTER //
// src/components/home-swiper/home-swiper.vue